const onResize = (context, pageWrapper) => {
  const pageWidth = pageWrapper.offsetWidth;
  // Max width of content.
  const percentageWhiteSpace = 1 - (context.state.contentWidth / pageWidth);

  const pixelsFree = percentageWhiteSpace * pageWidth;

  if (pixelsFree > context.state.buttonWrapperWidth) {
    context.commit("SET_BUTTONS_EXPANDED", true);
  } else {
    context.commit("SET_BUTTONS_EXPANDED", false);
  }
};

const listenForResize = (context, pageWrapper) => {
  if (!pageWrapper || context.state.contentWidth === null) {
    return;
  }

  // On initial load, call onResize to set the initial state
  onResize(context, pageWrapper);
  // Create a new Resize Observer instance
  const resizeObserver = new ResizeObserver(() => {
    onResize(context, pageWrapper);
  });
  // Start observing the target element
  resizeObserver.observe(pageWrapper);
};
export default {
  listenForResize,
};
